/**
*
* Mutations WebApp Orange
*
*/

import {
    UPDATE_CURRENT_STEP,
    UPDATE_OPTION_STATE,
} from './types/mutationsTypes'

/**
*
* Mutations ProductFile Orange
*
*/

const mutations = {
    [UPDATE_CURRENT_STEP]: (state, currentStep) => {
        state.currentStep = currentStep
    },
    [UPDATE_OPTION_STATE]: (state, optionState) => {
        state.optionState = optionState
    }
}

export default mutations
